import styled from 'styled-components';

import StyledLink from '@ui/atoms/StyledLink';

export const CenteredLink = styled(StyledLink)`
	font-size: 1.4rem;
	align-self: center;
`;
